import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import FormPage from 'src/presentation/components/pages/shared/FormPage';
import organizationResource from 'src/actions/organization/organizationResource';
import ssoConfigResource from 'src/actions/integrations/sso/ssoConfigResource';
import SsoForm from './SsoForm';
import { STATUS_LOADING } from 'src/presentation/hooks/useResource';
import { RootState } from 'src/actions/configuration/rootReducer';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';

const Sso: FC = () => {
  const { errors, loadingState, value } = useDocumentResource(ssoConfigResource);
  const description = (
    <span>
      Configure your Single-Sign On (SSO), so that users can log in to Gladly without creating a new username and
      password. To learn more about SSO, visit{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://help.gladly.com/docs/single-sign-on-setup">
        Help Docs
      </a>
      .
    </span>
  );

  const orgId = useSelector((state: RootState) => state.auth.orgId);
  const { loadingState: organizationLoadingState } = useDocumentResource(organizationResource, {
    fetch: true,
    params: { orgId },
  }); // preload resource for quicker access in the form

  return (
    <FormPage
      isLoading={loadingState === STATUS_LOADING || organizationLoadingState === STATUS_LOADING}
      form={SsoForm}
      title="Single Sign-On"
      description={description}
      item={value}
      errors={errors}
      resetErrors={ssoConfigResource.actions.resetErrors}
      data-aid="admin-sso-page"
    />
  );
};

export default Sso;
